import {
    Box,
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    LinearProgress,
    Typography
} from "@mui/material";
import * as React from "react";
import ToggleLiveSandbox from "./ToggleLiveSandbox";
import {useEffect, useState} from "react";
import LoginToken from "../../../../local_storage/LoginToken";
import PaypalLoginButton from "./PaypalLoginButton";

async function getCredentials(accessToken) {
    return fetch(process.env.REACT_APP_SERVER_URL + '/paypal/database', {
        method: 'GET',
        headers: { 'Authorization': accessToken },
    }).then(data => data.json());
}

export default function PaypalComponent({}) {

    let {getToken} = LoginToken();

    const [account, setAccount] = React.useState(1);
    const [firstRender, setFirstRender] = useState(true);
    const [paypalCredentials, setPaypalCredentials] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if(firstRender) {
            setLoading(true)
            getCredentials(getToken().token).then(result => {
                if(result.state) {
                    setPaypalCredentials(result.data);
                } else {
                    setError(result?.message || "Error on getting data.")
                }
                setLoading(false);
                console.log({result});
                setFirstRender(false)
            }).catch(err => {
                setLoading(false);
                setError(err?.message || "Error on getting data.")
            })
        }
    }, [firstRender]);
    useEffect(() => {
        console.log({account});
    }, [account]);

    return (
        <Box sx={{display:'flex', flexDirection:'column', gap:2}}>
            <ToggleLiveSandbox account={account} setAccount={setAccount}/>
            {
                loading
                    ?
                    <LinearProgress/>
                    :
                    <AllPaymentCredentials array={paypalCredentials}/>
            }
            <AddPaypalAccount disabled={loading} account={account}/>
        </Box>
    )
}

function AddPaypalAccount({account, disabled}) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Button variant="outlined" onClick={handleClickOpen} disabled={disabled}>
                Connect Account
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
            >
                <DialogTitle >
                    Connect {account === 1 ? 'sandbox' : 'live'} paypay account.
                </DialogTitle>
                <DialogContent>
                    <DialogContentText >
                        <Box>
                            <PaypalLoginButton/>
                        </Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

function AllPaymentCredentials({array}) {
    if(array && array?.length > 0) {
        return (
            <Box>
                {array.forEach(p => <Typography>{p.paypal_email}</Typography>)}
            </Box>
        )
    }
    return (
        <Box>
            <Typography>You dont have connected accounts</Typography>
        </Box>
    )
}
